

























/* eslint-disable @typescript-eslint/no-unused-vars */
import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters, mapState } from 'vuex'

@Component({
    methods: {
        ...mapActions('auth', ['setAcceptRGPD'])
    },
    computed: {
        ...mapState('auth', ['error', 'acceptRGPD']),
        ...mapGetters('auth', ['is_intervenant_centre_nodirection'])
    }
})
export default class AcceptRGPD extends Vue {
    @Watch('acceptRGPD')
    redirect () {
        if (this.$store.state.auth.acceptRGPD) {
            if (this.$store.getters['auth/is_intervenant_centre_nodirection']) {
                this.$router.push('/dashboard_i').catch(() => { console.log('Erreur de redirection') })
            } else {
                this.$router.push('/dashboard').catch(() => { console.log('Erreur de redirection') })
            }
        }
    }

    errors = ''
    message = ''
    app_url = process.env.VUE_APP_URL

    async sendAcceptation () {
        this.$store.dispatch('auth/setAcceptRGPD').then(() => {
            if (this.$store.state.auth.acceptRGPD) {
                if (this.$store.getters['auth/is_intervenant_centre_nodirection']) {
                    this.$router.push('/dashboard_i').catch(() => { console.log('Erreur de redirection') })
                } else {
                    this.$router.push('/dashboard').catch(() => { console.log('Erreur de redirection') })
                }
            }
        })
    }

    // Déconnexion
    logout () {
        this.$store.dispatch('auth/logout')
    }
}
